class HoloAnnouncementMarquee extends HTMLElement {
  constructor() {
    super();
    this.onResize = () => this.setup();
    this.onSectionLoad = (event) => {
      if (event.target?.contains(this)) this.setup();
    };
  }

  connectedCallback() {
    this.track = this.querySelector('.holo-announcement-marquee__track');
    this.group = this.querySelector('.holo-announcement-marquee__group');
    if (!this.track || !this.group) return;

    this.setup();
    window.addEventListener('resize', this.onResize, { passive: true });
    document.addEventListener('shopify:section:load', this.onSectionLoad);

    if (document.fonts?.ready) {
      document.fonts.ready.then(() => this.setup());
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.onResize);
    document.removeEventListener('shopify:section:load', this.onSectionLoad);
  }

  setup() {
    const group = this.group;
    if (!group || !this.track) return;

    this.track.querySelectorAll('.holo-announcement-marquee__group').forEach((element, index) => {
      if (index > 0) element.remove();
    });

    const containerWidth = this.querySelector('.holo-announcement-marquee')?.clientWidth || this.clientWidth;
    const groupWidth = group.getBoundingClientRect().width;
    let copies = 2;

    while (groupWidth * copies < containerWidth * 2) {
      copies += 1;
    }

    for (let index = 1; index < copies; index += 1) {
      const clone = group.cloneNode(true);
      clone.setAttribute('aria-hidden', 'true');
      this.track.appendChild(clone);
    }

    this.track.style.setProperty('--holo-marquee-distance', `-${groupWidth}px`);
  }
}

if (!customElements.get('holo-announcement-marquee')) {
  customElements.define('holo-announcement-marquee', HoloAnnouncementMarquee);
}
